const error404 = {
  name: 'Erro 404',
  title: 'Puxa! Página indisponível',
  subtitle: 'O link que você está tentando acessar está incorreto.',
};

export default error404;
